module.exports = __webpack_public_path__ + "7c75f0d12633328b06100e74dd8a72c0.png";